
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feature-your-io-game",
      function () {
        return require("private-next-pages/feature-your-io-game/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feature-your-io-game"])
      });
    }
  